import icon from './weibo.svg';

import type { Provider } from '../providers'

export default {
    key: 'weibo',
    name: 'Weibo',
    color: '#e71d34',
    icon
} satisfies Provider;
